import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/about")({
  head: () =>
    seo({
      title: "About Cedar Creek Construction | Minnesota Roofing & Siding",
      description:
        "Family-owned Minnesota roofing and siding contractor. Licensed #BC645307, serving Minneapolis and the north metro for 20+ years. Meet the crew.",
      path: "/about",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
      ]),
    }),
  component: About,
});
